module.exports = __webpack_public_path__ + "22847aa9656b95bee7fc2530829e1b3a.MP3";